import { render, staticRenderFns } from "./KapusdokkesList.vue?vue&type=template&id=7f009b69"
import script from "./KapusdokkesList.vue?vue&type=script&lang=js"
export * from "./KapusdokkesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports